import httpService from 'services/http/http.service';
import ApiUrl from 'enum/api-url.enum';
import StorageKeys from 'enum/storages.enum';
import Storages from 'storages';

function getOrganizationTemplate() {
  return httpService.get(ApiUrl.ORGANIZATIONTEMPLATE + '?organization_id=' + Storages.MainStorage.getItem(StorageKeys.Keys.LICENSEAPIKEY).organization_id);
}

const obj = { getOrganizationTemplate };

export default obj;
